import React, { useMemo } from "react";

import { enhanceRichTextMedia } from "../../utils/mediaEmbeds";

type RichTextContentProps = {
  html: string;
  className?: string;
};

const RichTextContent: React.FC<RichTextContentProps> = ({
  html,
  className = "blog-details__text",
}) => {
  const enhancedHtml = useMemo(() => enhanceRichTextMedia(html), [html]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: enhancedHtml }}
    />
  );
};

export default RichTextContent;
